import InstallCodePage from './InstallCodePage';
export default InstallCodePage;
